import React from 'react';
import { PuffLoader } from 'react-spinners';

const BookmarkLoader = () => <PuffLoader color={'#fff'} size={30} css="display: flex; margin-right: 1rem" />;

export default BookmarkLoader;
